var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{key:_vm.$route.path,staticStyle:{"width":"100%","height":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }